import { useAbExperimentBucket } from '#/hooks/abExperiment/useAbExperimentBucket';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { SearchType } from '#/modules/search/types/SearchType';
import { LISTING_TYPE_HUMAN_NAME_MAP_SEARCH } from '#/utils/constants/general/listingTypeHumanNameMapSearch';

import { UncontrolledListingTypeSelectStyled } from './UncontrolledListingTypeSelect.styled';

type Props = {
  name: string;
  defaultValue: SearchType;
  searchTypes: SearchType[];
  variant: 'grey' | 'outline-blue';
  onChange?: (option: SearchType) => void;
};

export function UncontrolledListingTypeSelect({
  name,
  defaultValue,
  searchTypes,
  variant,
  onChange,
}: Props) {
  const { i18n } = useI18n();

  const allOptions = searchTypes.map((type) => ({
    value: type,
    label: LISTING_TYPE_HUMAN_NAME_MAP_SEARCH(i18n)[type],
  }));

  const groupsSearchEnabled =
    useAbExperimentBucket('GROUPS_SEARCH_2026_09') === 'ENABLED';

  const options = groupsSearchEnabled
    ? allOptions
    : allOptions.filter((option) => option.value !== 'GROUP');

  return (
    <UncontrolledListingTypeSelectStyled
      qaId="listing-type-select"
      aria-label={i18n('Select listing type')}
      name={name}
      options={options}
      defaultValue={defaultValue}
      // NOTE passing key={defaultValue} so it's remounted (sc-64870)
      key={defaultValue}
      disabled={searchTypes.length === 1}
      height={48}
      $variant={variant}
      onChange={
        onChange ? (newValue) => onChange(newValue as SearchType) : undefined
      }
    />
  );
}
